<template>
  <section-box has-no-padding>
    <div :class="['comms_list', {'is_empty': !comms.length}]">
      <template v-if="comms.length">
        <comm-log-item
          v-for="comm in futureComms"
          :key="comm.id"
          :comm="comm"
          show-type-icons
          show-user-avatar
        ></comm-log-item>

        <app-divider v-if="futureComms.length" class="my-150">
          <icon-default icon="down"/>
          Scheduled Messages
          <icon-default icon="down"/>
        </app-divider>

        <comm-log-item
          v-for="comm in pastComms"
          :key="comm.id"
          :comm="comm"
          show-type-icons
          show-user-avatar
        ></comm-log-item>

        <div class="flex flex-centered mt-100 mb-150">
          <button-link
            v-if="showLoadMoreButton"
            @click="loadMoreComms"
            :loading="isLoadingMoreComms"
          >Load More Comms</button-link>

          <p v-else class="is-italic is-size-7 has-text-light">-- End of Log --</p>
        </div>
      </template>
      <p v-else class="empty_message">No comms for this lead</p>
    </div>
  </section-box>
</template>

<script>
import CommLogItem from "../../../../../components/comms/components/CommLogItem";

export default {
  name: "FollowUpCommLog",
  components: {CommLogItem},
  props: {
    record: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      isLoadingMoreComms: false,
    }
  },
  computed: {
    comms() {
      return this.$store.getters["activeFollowUpStateItem/communicationLogs"];
    },
    pastComms() {
      return this.comms.filter(comm => !comm.is_scheduled);
    },
    futureComms() {
      return this.comms.filter(comm => comm.is_scheduled);
    },
    showLoadMoreButton() {
      return this.$store.state.activeFollowUpStateItem.showMoreCommsButton
    }
  },
  methods: {
    loadMoreComms() {
      this.isLoadingMoreComms = true

      this.$store.dispatch("activeFollowUpStateItem/getCommLogs", this.record.id)
        .finally(() => {
          this.isLoadingMoreComms = false
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../../styles/variables/variables";

.comms_list {
  display: flex;
  flex-direction: column-reverse;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 14px;

  &.is_empty {
    justify-content: center;
    align-items: center;
  }
}

.empty_message {
  font-size: 1.125rem;
  font-style: italic;
  color: $text-light;
}
</style>
